module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kWhFt"))).then(() => parcelRequire('d0iPb'));